import { Injectable } from '@angular/core';
import * as dayjs from "dayjs";

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  timestampToFormat(timestamp, format = 'DD/MM/YYYY HH:mm:ss') {
      return dayjs.unix(timestamp).format(format);
  }
}
